export const reduxFormFieldWrapper = render => ({ type, input, component: Component, meta, ...rest }) => {
    const _onChange = (e, data) => {
        let value;
        if (data) {
            if (type === 'checkbox') {
                const { name, checked } = data;
                value = checked ? name : '';
            }
            else {
                value = data.value;
            }
        }
        else {
            value = e;
        }
        input.onChange(value);
    };
    const props = {
        ...input,
        ...rest,
        type,
        error: meta ? meta.error : undefined,
        touched: meta ? meta.touched : undefined,
        warning: meta ? meta.warning : undefined,
        onChange: _onChange,
        ...(type === 'checkbox' ? { value: input.name } : {}),
        ...(type === 'checkbox' ? { checked: !!input.value } : {}),
    };
    return render(props);
};
//# sourceMappingURL=index.js.map